module.exports = __webpack_public_path__ + "media/images/icon_list/bookmark_filled-bf0cc6180a9129483f2cb3351db94af8.svg";